"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var OutletSearch = /** @class */ (function (_super) {
    __extends(OutletSearch, _super);
    function OutletSearch(props) {
        return _super.call(this, props) || this;
    }
    OutletSearch.prototype.render = function () {
        var venues = this.props.venues;
        if (venues.length === 0)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { onContextMenu: function (e) { return e.preventDefault(); } },
                React.createElement("h2", null, "Venue Details "),
                this.renderForecastsTable(venues))));
    };
    OutletSearch.prototype.renderForecastsTable = function (venues) {
        var disabled = true;
        return (React.createElement("table", { className: 'table table-striped', "aria-labelledby": "tabelLabel" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { colSpan: 6 },
                        "Total Venues Found : ",
                        venues.venues.length,
                        " of ",
                        venues.totalVenuesFound,
                        " Refine your search"))),
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '150px' } }, " OTD OutletID "),
                    React.createElement("th", null, " Name "),
                    React.createElement("th", null, " Address "),
                    React.createElement("th", null, " Suburb "),
                    React.createElement("th", null, " Postcode "),
                    React.createElement("th", null, " State "),
                    React.createElement("th", { style: { width: '160px' } }, " Phone Number"))),
            React.createElement("tbody", null,
                this.props.venues.venues.map(function (venue) {
                    return React.createElement("tr", { key: venue.venueId },
                        React.createElement("td", { style: { pointerEvents: "auto", userSelect: "auto" } },
                            venue.venueId,
                            " "),
                        React.createElement("td", { style: disabled ? { pointerEvents: "none", userSelect: "none" } : {} },
                            venue.name,
                            " "),
                        React.createElement("td", { style: disabled ? { pointerEvents: "none", userSelect: "none" } : {} }, venue.address),
                        React.createElement("td", { style: disabled ? { pointerEvents: "none", userSelect: "none" } : {} }, venue.suburb),
                        React.createElement("td", { style: disabled ? { pointerEvents: "none", userSelect: "none" } : {} }, venue.postcode),
                        React.createElement("td", { style: disabled ? { pointerEvents: "none", userSelect: "none" } : {} }, venue.state),
                        React.createElement("td", { style: disabled ? { pointerEvents: "none", userSelect: "none" } : {} },
                            venue.phone,
                            " "));
                }),
                this.props.venues.venues.length === 0 && (React.createElement("tr", null,
                    React.createElement("td", { colSpan: 7 },
                        React.createElement("span", { className: "d-block p-2 bg-dark text-white" }, "No records found for this search criteria.")))))));
    };
    return OutletSearch;
}(React.PureComponent));
exports.OutletSearch = OutletSearch;
exports.default = react_redux_1.connect()(OutletSearch);
//# sourceMappingURL=OutletSearch.js.map